import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrustedImg from "../../images/location_new/fold11/Dallas.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Trustedcompany(props) {
  return (
    <div className="trusted_company p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Transform Your Business with TekRevol’s Mobile App Development
              Services in Dallas
            </h2>
            <p>
              TekRevol is dedicated to ensuring confidence, clarity, and
              openness in the process of mobile app development in Dallas. Our
              services include presenting you with UX/UI components that elevate
              the user's browsing experience as they navigate the app. As a
              result, we created a scalable and effective technical structure,
              examining functionalities for technical issues, and providing
              technical support.
            </p>
            <p>
              Meanwhile, our mobile app development company Dallas leverages its
              years of experience, unparalleled problem-solving skills, and
              rigorous testing to ensure the impact of your app before it is
              ready to enter the market.
            </p>
            <p>
              Our unconventional approach to developing software ensures that we
              can provide mobile applications that meet your project
              specifications and are resistant to obsolescence.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Let's Connect!
            </Link>
          </Col>
          <Col xs={12} md={12} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="trustedimg">
              <LazyLoadImage
                src={TrustedImg}
                effect="blur"
                alt="TrustedImg"
                className="img-fluid"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Trustedcompany;
